// extracted by mini-css-extract-plugin
module.exports = {"layout":"EssentialPricePlanResources_layout__1MxOw","pricePlan":"EssentialPricePlanResources_pricePlan__3K33x"};